<template>
  <v-expansion-panels :value="null">
    <v-expansion-panel>
      <v-expansion-panel-header class="expansion-panel-border green">
        <v-row>
          <v-icon>settings</v-icon>
          <h3 class="title text-uppercase ml-3">
            Продукти
            <span v-if="products.length">({{ products.length }})</span>
          </h3>
        </v-row>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-row v-if="products.length">
          <v-col>
            <v-data-table
              :headers="headers"
              :items="products"
              hide-default-footer
              disable-sort
              class="elevation-0"
            >
              <template v-slot:item="{ item }">
                <tr
                  :class="[{ red: item.version && item.isExpiredVersion}, 'lighten-4']"
                >
                  <td>
                    {{ item.title }}
                  </td>
                  <td>
                    {{ item.regNumber }}
                  </td>
                  <td>
                    {{ item.actualVersion }}
                  </td>
                  <td>
                    {{ item.version }}
                  </td>
                  <td v-html="item.actualVersionNotes" />
                  <td>
                    <UpdateByChip :update-by-client="item.updateByClient" />
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col>
            <h4>
              Щоб додати продукт зверніться до менеджера
            </h4>
          </v-col>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { mapState } from "vuex";
import UpdateByChip from "@/components/UpdateByChip.vue";

export default {
  components: {
    UpdateByChip,
  },
  data: () => ({
    activeTab: "",
    headers: [
      { value: "title", width: "80%" },
      { text: "Реєстраційний номер", value: "regNumber" },
      { text: "Актуальна версія", value: "actualVersion" },
      { text: "Версія клієнта", value: "version" },
      { text: "Опис оновлення", value: "actualVersionNotes" },
      { text: "Оновлення", value: "updateByClient" },
    ],
  }),
  computed: {
    ...mapState("client", ["products"]),
  },
};
</script>